import { formatUsd } from './pulseTotals.js'
import { isHistoryEntered, paymentTiming, typicalPayLine } from './pulsePaymentTiming.js'
import PulseActor from './PulseActor'
import type { PulsePaymentRow, PulsePaymentsPayload } from './pulseApi'

function displayDate(iso: string | null) {
  if (!iso) return '—'
  const m = String(iso).match(/^(\d{4})-(\d{2})-(\d{2})/)
  if (!m) return String(iso)
  return `${Number(m[2])}/${Number(m[3])}/${m[1]}`
}

export default function PulsePaymentsSection({
  payload,
  payAppId,
  onOpen,
}: {
  payload?: PulsePaymentsPayload | null
  payAppId?: number
  onOpen: (row: PulsePaymentRow) => void
}) {
  const rows = (payload?.payments || []).filter((p) => payAppId == null || Number(p.pay_app_id) === payAppId)
  const typical = typicalPayLine({
    owner: payload?.typical?.owner,
    n: payload?.typical?.n_paid,
    medianDays: payload?.typical?.median_days,
  })
  const collected = payload?.collected ?? rows.reduce((s, r) => s + Number(r.amount || 0), 0)
  return (
    <section className="pulse-pays" data-testid="pulse-payments" id="pulse-payments">
      <div className="pulse-kicker">Payments received</div>
      <p className="pulse-pay-typical" data-testid="pulse-pay-typical">{typical}</p>
      {rows.length === 0 ? (
        <p className="pulse-empty">No payments recorded yet.</p>
      ) : (
        <ul className="pulse-pay-list">
          {rows.map((p) => {
            const history = isHistoryEntered({
              paidAt: p.paid_at,
              submittedAt: p.submitted_at,
              dueDate: p.due_date,
              termsDays: payload?.terms_days,
              paymentTerms: payload?.payment_terms,
            })
            const chip = history ? null : paymentTiming({ dueDate: p.due_date, paidAt: p.paid_at })
            return (
              <li key={`${p.source}-${p.id}`}>
                <button
                  type="button"
                  className="pulse-pay-row"
                  data-testid={`pulse-pay-row-${p.source}-${p.id}`}
                  onClick={() => onOpen(p)}
                >
                  <PulseActor name={p.actor} />
                  <span title={history ? 'Entered from history' : undefined}>{displayDate(p.paid_at)}</span>
                  <span>{p.method || '—'}</span>
                  <span>PA {p.app_number ?? p.pay_app_id}</span>
                  <span>{formatUsd(p.amount)}</span>
                  {chip ? (
                    <span className={`pulse-pay-chip pulse-pay-chip-${chip.kind}`} data-testid="pulse-pay-chip" data-kind={chip.kind}>
                      {chip.label}
                    </span>
                  ) : null}
                </button>
              </li>
            )
          })}
        </ul>
      )}
      <div className="pulse-pay-total" data-testid="pulse-pay-total">Collected to date {formatUsd(collected)}</div>
    </section>
  )
}
